import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';
import { Link } from 'react-router';
import { withPageContainerStyles } from '@/common/components/page-layout';
import React from 'react';
import useWebpWithPngFallback from '@/common/hooks/use-webp-with-png-fallback';
import { chargingEVsSupportUrl } from '@/catalog/constants/support-urls';

export interface EVHeroChargingProps {
  prefix: string;
}

export default function EVHeroCharging({ prefix }: EVHeroChargingProps) {
  const imageSrc = useWebpWithPngFallback(`${prefix}/ev-hero-charging.webp`);

  return (
    <div className="flex min-h-[622px] min-w-full flex-col bg-flexcar-neutral1 lg:min-h-[338px] lg:flex-row lg:justify-start">
      <div
        style={
          {
            '--ev-recharge-desktop': `linear-gradient(270deg, ${colors.neutral1} 0%, transparent 29.2%), url(${imageSrc})`,
            '--ev-recharge-mobile': `linear-gradient(0deg, ${colors.neutral1} 0%, transparent 45.8%), url(${imageSrc})`,
          } as React.CSSProperties
        }
        className="relative min-h-[388px] min-w-full bg-[image:var(--ev-recharge-mobile)] bg-[size:auto,auto_105%] bg-[position:0%_0%,_bottom_20%_right_37%] bg-no-repeat min-[430px]:bg-[size:auto,auto_112%] min-[430px]:bg-[position:0%_0%,_bottom_10%_right_43%] sm:bg-[size:auto,120%] sm:bg-[position:0%_0%,_right_70%_center] md:bg-cover md:bg-[position:0%_0%,_right_70%_bottom_40%] lg:min-h-[351px] lg:min-w-[50%] lg:bg-[image:var(--ev-recharge-desktop)] lg:bg-[position:0%_0%,_center_right]"
      />
      <div
        className={withPageContainerStyles(
          // Note: This is half of the page container width 1440px / 2 = 720px
          'flex w-full max-w-[720px] flex-col gap-4 py-10 lg:justify-center lg:pl-10'
        )}
      >
        <h1 className="text-flexcar-neutral100">Charge at home, work, and beyond</h1>
        <p className="text-flexcar-neutral100">
          Save time by charging your electric vehicle at home or work — you can charge
          with ease using an outlet or a charging station. Additionally, there are about
          500 public charging stations in Massachusetts and 250 in the Boston area alone.
        </p>
        <Link
          to={chargingEVsSupportUrl}
          target="_blank"
          rel="noreferrer"
          className={cn(
            'link-body w-fit',
            'font-bold text-flexcar-neutral100 hover:text-flexcar-neutral100 focus:border-flexcar-neutral100'
          )}
        >
          Learn more about charging {'->'}
        </Link>
      </div>
    </div>
  );
}
